// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3LKdG","approved":"Status_approved__1zPtz","rejected":"Status_rejected__3zqY-","expired":"Status_expired__334Di","label":"Status_label__yWDHF"};